var map = {
	"./arrow-down.svg": "c874",
	"./arrow-go-right.svg": "723d",
	"./arrow_drop.svg": "526b",
	"./close.svg": "8b1b",
	"./facebook.svg": "8485",
	"./home.svg": "ac9d",
	"./instagram.svg": "bd6c",
	"./left-arrow.svg": "6d4b",
	"./mail-footer.svg": "f540",
	"./mail.svg": "3ae9",
	"./mobile.svg": "0df4",
	"./phone.svg": "c3bb",
	"./pin.svg": "862b",
	"./play.svg": "dab1",
	"./right-arrow.svg": "c686",
	"./telegram.svg": "2b29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";